require.register("work/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

